export default "<div id=\"copyright\">© {{getCurrentYear()}} <a href=\"mailto:contact@naterussell.com\">Nathan Russell</a></div>\r\n"